import { jsx as _jsx } from "react/jsx-runtime";
import { detectBankFromIban } from '@libs/helpers';
import { AlertIcon } from '../assets';
import { BANK_ICONS } from '../constants';
const BankIcon = ({ iban, code }) => {
    if (code) {
        const Icon = BANK_ICONS[code] ?? AlertIcon;
        return _jsx(Icon, {});
    }
    if (!iban)
        return null;
    const { code: bankCode } = detectBankFromIban(iban);
    const IconFromIBAN = BANK_ICONS[bankCode] ?? AlertIcon;
    return _jsx(IconFromIBAN, {});
};
export default BankIcon;
//# sourceMappingURL=BankIcon.js.map